import type { ComponentType } from 'react'
import type { Experiments } from '@wix/thunderbolt-symbols'
import React, { forwardRef } from 'react'
import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { withInteractions } from '@wix/builder-interactions'
import { ExperimentsSymbol, SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from './symbols'

export const InteractionsComponentWrapper = withDependencies(
	[named(SiteFeatureConfigSymbol, name), ExperimentsSymbol],
	({ isBuilderComponentModel }, experiments: Experiments) => {
		const interactionsFeatureExperiment = Boolean(experiments['specs.thunderbolt.interactionsFeature'])
		const servicesInfraExperiment = Boolean(experiments['specs.thunderbolt.servicesInfra'])

		const shouldWrap = (interactionsFeatureExperiment && servicesInfraExperiment) || isBuilderComponentModel

		return {
			wrapComponent: (Component: ComponentType<any>) => {
				const WrappedComponent = shouldWrap ? withInteractions(Component) : Component
				const Wrapper = forwardRef<any, any>((props, ref) => <WrappedComponent {...props} ref={ref} />)
				return Wrapper
			},
		}
	}
)
